import ButtonIconLink from "tds/buttonIconLink";

export { ButtonIconLink };

customElements.define(
  "tds-button-icon-link",
  ButtonIconLink.CustomElementConstructor
);
